import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HOME_LAYOUT_WIDTH } from "../../app/common";

export const StyledTableContainer = styled(Box)({
  width: `calc(${HOME_LAYOUT_WIDTH} - 16px)`,
  backgroundColor: "white",
  padding: "1em",
  borderRadius: "8px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

export const ScrollContainer = styled(Box)({
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "auto",
  scrollbarWidth: "none",
});
